// export default defineNuxtRouteMiddleware(async (to) => {
//     const tokenQuery = to.query.token as string | null;
  
//     // If token exists in query, store and redirect
//     if (tokenQuery) {
//       if (process.client) {
//         localStorage.setItem('auth_token', tokenQuery);
//       }
  
//       const tokenCookie = useCookie('auth_token', { path: '/' });
//       tokenCookie.value = tokenQuery;
  
//       // Remove token from URL
//       const { token, ...restQuery } = to.query;
//       return navigateTo({ path: to.path, query: restQuery });
//     }
  
//     // Check for existing token
//     const token = process.client 
//       ? localStorage.getItem('auth_token') 
//       : useCookie('auth_token').value;
  
//     // Redirect if no token
//     if (!token && to.path !== '/auth/signin') {
//       // return navigateTo('/auth/signin');
//       // redir to login page 
//       return navigateTo("http://localhost:5173/api-auth/login", {external: true})
//     }

//     // TODO use jose lib para verificar el sign del token. 
//     //   // 5. (Optional) You can also verify expiry/signature here
// //   //    e.g. using jose.jwtVerify as shown previously.
  
//     // Ensure middleware explicitly returns nothing if authenticated
//     return;
//   });

export default defineNuxtRouteMiddleware(async (to) => {
  // Only apply middleware to routes starting with "/cloud"
  if (!to.path.startsWith('/cloud')) {
    return;
  }

  const tokenQuery = to.query.token as string | null;

  // If token exists in query, store and redirect
  if (tokenQuery) {
    if (process.client) {
      localStorage.setItem('auth_token', tokenQuery);
    }

    const tokenCookie = useCookie('auth_token', { path: '/' });
    tokenCookie.value = tokenQuery;

    // Remove token from URL
    const { token, ...restQuery } = to.query;
    return navigateTo({ path: to.path, query: restQuery });
  }

  // Check for existing token
  const token = process.client 
    ? localStorage.getItem('auth_token') 
    : useCookie('auth_token').value;

  // Redirect if no token
  if (!token && to.path !== '/auth/signin') {
    return navigateTo("http://localhost:5173/api-auth/login", { external: true });
  }

  return;
});
